var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize:throttle",value:(_vm.scaleCards),expression:"scaleCards",arg:"throttle"}],ref:"deck",staticClass:"deck"},[_c('div',{ref:"cards",staticClass:"playingcards-wrapper",style:({
             transform: 'scale(' + _vm.scale + ')',
             opacity: _vm.opacity,
         })},_vm._l((_vm.room.deck),function(card,i){return _c('div',{key:i,staticClass:"playingcard-rotate",style:({
                 transform: _vm.getRotate(i),
                 zIndex: card.properties.zindex,
                 display: card.revealed ? 'none' : 'block',
             })},[_c('div',{staticClass:"playingcard-translate",style:({
                     transform:
                         'translateY(' +
                         parseInt(180 + card.properties.translation) +
                         'px)',
                 })},[_c('a',{ref:card.identifier,refInFor:true,staticClass:"playingcard",class:_vm.cardTheme,attrs:{"id":card.identifier,"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.pickCard.apply(null, arguments)}}},[_vm._m(0,true)])])])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner"},[_c('div',{staticClass:"front"}),_c('div',{staticClass:"back"})])
}]

export { render, staticRenderFns }